function CheckoutEnquiryValidation(Values = {}) {

  // if (Values.name) {
  //   error.name = Values.name;
  // } else {
  //   error.name = "";
  // }

  // if (Values.number) {
  //   error.number = Values.number;
  // } else {
  //   error.number = "";
  // }

  // if (Values.category) {
  //   error.category = Values.category;
  // } else {
  //   error.category = "";
  // }


  let error = {};

  if (Values.name) {
    error.name = Values.name;
  }

  if (Values.number) {
    error.number = Values.number;
  }

  if (Values.category) {
    error.category = Values.category;
  }



  return error;
}

export default CheckoutEnquiryValidation;
